import React from 'react'
import { Container, Content, Header } from './styles'
import { ConductAndOmics } from '~/components/healthProcedures/ConductAndOmics'
import { HealthProcedureAccordionCardList } from '~/components/healthProcedures/HealthProcedureAccordionCardList'
import { ListCardHealthProcedure } from '~/components/healthProcedures/ListCardHealthProcedure'
import { Tag } from '~/components/shared'
import { SidePanel } from '~/components/shared/medicalViews'
import { ContainerTags } from '~/components/shared/medicalViews/sidePanel/styles'
import { useOncologyHealthProcedures } from '~/context'
import { IFilterTag, IHealthProceduresConduct, IHealthProceduresOmics } from '~/interfaces'
import { message } from '~/services'
import { filterHealthProceduresPer, isConduct, isOmics, timelineFilters } from '~/utils'

const OncologySidePanelComponent = (): JSX.Element => {
  const {
    sidePanelEvents,

    openConductCardList,
    setOpenConductCardList,
    openOmicsCardList,
    setOpenOmicsCardList,

    filterTags,
    dateFiltersActive,
    typeFiltersActive,
    removeFilterTag,

    selectMedicalEventForDetailing
  } = useOncologyHealthProcedures()

  const searchTerms = filterTags?.filter(tag => tag.type === 'searchTerm').map(tag => tag.text)
  const filteredMedicalEvents = timelineFilters(sidePanelEvents)
    .perDate(dateFiltersActive)
    .perType(typeFiltersActive)
    .perMultipleTextTerms(searchTerms).value

  const medicalEventsOfConductPanel = filterHealthProceduresPer(filteredMedicalEvents, isConduct)
  const medicalEventsOfOmicsPanel = filterHealthProceduresPer(filteredMedicalEvents, isOmics)

  const handleSelectDataConduct = (healthProcedure: IHealthProceduresConduct) => {
    selectMedicalEventForDetailing(healthProcedure)
  }

  const handleSelectDataOmics = (healthProcedure: IHealthProceduresOmics) => {
    selectMedicalEventForDetailing(healthProcedure)
  }

  const handleCloseFilterTag = (tag: IFilterTag) => removeFilterTag(tag)

  return (
    <>
      <SidePanel>
        <Container>
          <Header>
            <ContainerTags>
              {filterTags.map((tag, index) => {
                const { id, text, color } = tag
                return (
                  <Tag key={`${id}-${index}`} text={text} color={color} onClose={() => handleCloseFilterTag(tag)} />
                )
              })}
            </ContainerTags>
          </Header>
          <Content>
            <ConductAndOmics>
              <HealthProcedureAccordionCardList
                title={message('healthProcedures.conduct')}
                expanded={openConductCardList}
                setExpanded={setOpenConductCardList}
              >
                <ListCardHealthProcedure
                  list={medicalEventsOfConductPanel}
                  onSelectCard={conduct => handleSelectDataConduct(conduct as IHealthProceduresConduct)}
                />
              </HealthProcedureAccordionCardList>

              <HealthProcedureAccordionCardList
                title={message('healthProcedures.omics')}
                expanded={openOmicsCardList}
                setExpanded={setOpenOmicsCardList}
              >
                <ListCardHealthProcedure
                  list={medicalEventsOfOmicsPanel}
                  onSelectCard={omics => handleSelectDataOmics(omics as IHealthProceduresOmics)}
                />
              </HealthProcedureAccordionCardList>
            </ConductAndOmics>
          </Content>
        </Container>
      </SidePanel>
    </>
  )
}

const withUserSummaries = (Component: React.FC) => {
  return Component
}

withUserSummaries.displayName = 'withUserSummaries'

export const OncologySidePanel = withUserSummaries(OncologySidePanelComponent)
